export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST"
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS"
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL"

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL"
export const USER_LOGOUT = "USER_LOGOUT"

export const USER_LIKED_REQUEST = "USER_LIKED_REQUEST"
export const USER_LIKED_SUCCESS = "USER_LIKED_SUCCESS"
export const USER_LIKED_FAIL = "USER_LIKED_FAIL"

export const USER_FOLLOW_REQUEST = "USER_FOLLOW_REQUEST"
export const USER_FOLLOW_SUCCESS = "USER_FOLLOW_SUCCESS"
export const USER_FOLLOW_FAIL = "USER_FOLLOW_FAIL"

export const USER_FOLLOWERS_FOLLOWING_REQUEST = "USER_FOLLOWERS_FOLLOWING_REQUEST"
export const USER_FOLLOWERS_FOLLOWING_SUCCESS = "USER_FOLLOWERS_FOLLOWING_SUCCESS"
export const USER_FOLLOWERS_FOLLOWING_FAIL = "USER_FOLLOWERS_FOLLOWING_FAIL"

export const USER_UPDATE_IMAGE_REQUEST = "USER_UPDATE_IMAGE_REQUEST"
export const USER_UPDATE_IMAGE_SUCCESS = "USER_UPDATE_IMAGE_SUCCESS"
export const USER_UPDATE_IMAGE_FAIL = "USER_UPDATE_IMAGE_FAIL"

export const USER_UPDATE_COVER_IMAGE_REQUEST = "USER_UPDATE_COVER_IMAGE_REQUEST"
export const USER_UPDATE_COVER_IMAGE_SUCCESS = "USER_UPDATE_COVER_IMAGE_SUCCESS"
export const USER_UPDATE_COVER_IMAGE_FAIL = "USER_UPDATE_COVER_IMAGE_FAIL"

export const USER_SEARCH_REQUEST = "USER_SEARCH_REQUEST"
export const USER_SEARCH_SUCCESS = "USER_SEARCH_SUCCESS"
export const USER_SEARCH_FAIL = "USER_SEARCH_FAIL"